import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../CSS/theme.css";
import "./Navbar.css";
import { NavLink } from "react-router-dom";

const Navbar = ({ currentPage }) => {
  const [isServicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [isBookDropdownOpen, setBookDropdownOpen] = useState(false);
  const [isAppointmentsDropdownOpen, setAppointmentsDropdownOpen] =
    useState(false);
  const [isMedicalDropdownOpen, setMedicalDropdownOpen] = useState(false);
  const [navbarColor, setNavbarColor] = useState("#00000030");
  const [contentColor, setContentColor] = useState("white");
  const [newNavIcon, setnewNavIcon] = useState("");

  const handleServicesHover = () => {
    setServicesDropdownOpen(true);
  };

  const handleServicesLeave = () => {
    setServicesDropdownOpen(false);
  };
  const handleAppointmentsHover = () => {
    setAppointmentsDropdownOpen(true);
  };

  const handleAppointmentsLeave = () => {
    setAppointmentsDropdownOpen(false);
  };
  const handleMedicalHover = () => {
    setMedicalDropdownOpen(true);
  };

  const handleMedicalLeave = () => {
    setMedicalDropdownOpen(false);
  };
  const handleBookHover = () => {
    setBookDropdownOpen(true);
  };

  const handleBookLeave = () => {
    setBookDropdownOpen(false);
  };

  const handleNavbarToggle = () => {
    // Close all dropdowns when the navbar toggler is clicked
    setServicesDropdownOpen(false);
    setAppointmentsDropdownOpen(false);
    setMedicalDropdownOpen(false);
    setBookDropdownOpen(false);
  };

  useEffect(() => {
    // Add a scroll event listener to update the navbar color on scroll
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const navbarThreshold = 80;
      const newNavbarColor =
        scrollPosition > navbarThreshold ? "white" : "#00000030"; //navbar color change on scroll
      const newContentColor =
        scrollPosition > navbarThreshold ? "#242424" : "white"; //navbar content color change after scroll
      const newNavIcon = scrollPosition > navbarThreshold ? "#242424" : "white"; //navbar content color change after scroll
      setNavbarColor(newNavbarColor);
      setContentColor(newContentColor);
      setnewNavIcon(newNavIcon);
    };

    // Attach the event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures the effect runs only once on mount

  return (
    <div className="nav-main-container">
      <nav
        className={` top-nav-tittle navbar navbar-expand-lg navbar-light fixed-top py-4 d-block`}
        style={{
          backgroundColor: navbarColor,
          boxShadow:
            navbarColor === "white" ? "0px 2px 4px rgba(0, 0, 0, 0.1)" : "none",
          transition: "background-color 0.5s ease", // Add transition for background-color
        }}
      >
        <div className="dr-imtiaz-name ">
          <NavLink to="/" style={{ textDecoration: "none" }}>
            <h2
              style={{
                color: contentColor,
                fontFamily: "'Dancing Script', sanf-serif",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: "46px",
              }}
              className="dr-text-tittle"
            >
              Dr Imtiaz Ahmed
            </h2>
            <div className="lower-navbar-text-tittle">
              <p
                style={{
                  fontSize: "20px",
                  // fontFamily: "serif",
                  fontWeight: "350",
                  marginTop: "-10px",
                  marginBottom: "-50px",
                  // maxWidth:"22%",
                  color: contentColor,
                  cursor: "pointer",
                }}
                className="lower-text-tille-sm"
              >
                Senior Consultant Dermatologist in
                <br />
                Coventry, Warwickshire and Leicester
              </p>
            </div>
          </NavLink>
        </div>

        <div className=" container container-fluid">
          <button
            className="navbar-toggler collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={handleNavbarToggle}
          >
            <span class="toggler-icon top-bar"></span>
            <span class="toggler-icon middle-bar"></span>
            <span class="toggler-icon bottom-bar"></span>
          </button>

          <div
            id="navbarSupportedContent"
            className="  mb-nav-background collapse navbar-collapse  border-lg-0 mt-4 mt-lg-0  "
          >
            <ul
              className=" mb-navbar-down navbar-nav ms-auto pt-2 pt-lg-0 font-base "
              style={{ marginTop: "80px" }}
            >
              <li className=" nav-item px-1 ">
                <a
                  className="mb-nav-link nav-link  "
                  href="/"
                  style={{ color: newNavIcon }}
                >
                  Home
                </a>
              </li>

              <li className=" nav-item px-1">
                <a
                  style={{ color: newNavIcon }}
                  className={`nav-link mb-nav-link ${
                    currentPage === "index" ? "active" : ""
                  }`}
                  aria-current="page"
                  href="/AboutUs"
                >
                  About
                </a>
              </li>

              <li
                className={`nav-item px-1 service-dropdown-mb ${
                  isServicesDropdownOpen ? "show" : ""
                }`}
                onMouseEnter={handleServicesHover}
                onMouseLeave={handleServicesLeave}
              >
                <a
                  className=" mb-nav-link nav-link dropdown-toggle"
                  href="#!"
                  role="button"
                  style={{ color: newNavIcon }}
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={isServicesDropdownOpen}
                >
                  Services
                </a>
                <div
                  className={`dropdown-menu mb-nav-link  ${
                    isServicesDropdownOpen ? "show" : ""
                  }`}
                  aria-labelledby="navbarDropdown"
                >
                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/SurgicalProcedures"
                  >
                    Surgical Procedures
                  </a>
                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/GeneralDermatology"
                  >
                    General Dermatology
                  </a>

                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/NonSurgicalProcedures"
                  >
                    Non – Surgical Procedures
                  </a>
                </div>
              </li>

              <li
                className={`nav-item px-1 service-dropdown-mb-sm-md  ${
                  isServicesDropdownOpen ? "show" : ""
                }`}
                onMouseEnter={handleServicesHover}
                onMouseLeave={handleServicesLeave}
                style={{ position: "relative" }}
              >
                <a
                  className=" mb-nav-link nav-link dropdown-toggle"
                  href="#!"
                  role="button"
                  style={{ color: newNavIcon }}
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={isServicesDropdownOpen}
                >
                  Services
                </a>
                <div
                  className={`dropdown-menu dropdown-menu-transition mb-nav-link ${
                    isServicesDropdownOpen ? "show" : ""
                  }`}
                  aria-labelledby="navbarDropdown"
                  style={{
                    position: "absolute",
                    left: "0px", // Align the dropdown to the right
                    animation: `${
                      isServicesDropdownOpen ? "slideIn" : "slideOut"
                    } 0.5s ease-in-out`, // Apply the animation
                  }}
                >
                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/SurgicalProcedures"
                  >
                    Surgical Procedures
                  </a>
                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/GeneralDermatology"
                  >
                    General Dermatology
                  </a>

                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/NonSurgicalProcedures"
                  >
                    Non – Surgical Procedures
                  </a>
                </div>
              </li>

              <li
                className={`nav-item px-1 service-dropdown-mb ${
                  isAppointmentsDropdownOpen ? "show" : ""
                }`}
                onMouseEnter={handleAppointmentsHover}
                onMouseLeave={handleAppointmentsLeave}
              >
                <a
                  className="mb-nav-link nav-link dropdown-toggle"
                  href="#!"
                  style={{ color: newNavIcon }}
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={isAppointmentsDropdownOpen}
                >
                  Appointments
                </a>
                <div
                  className={`dropdown-menu mb-nav-link ${
                    isAppointmentsDropdownOpen ? "show" : ""
                  }`}
                  aria-labelledby="navbarDropdown"
                >
                  <a className=" mb-nav-link-inner-b dropdown-item" href="/Fee">
                    Fees
                  </a>
                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/Referrals"
                  >
                    Referrals
                  </a>
                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/Prescription"
                  >
                    Prescription
                  </a>
                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/Consultations"
                  >
                    Consultations
                  </a>
                  {/* <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/Paediatric"
                  >
                    Paediatric Dermatology Clinics
                  </a> */}
                </div>
              </li>

              <li
                className={`nav-item px-1 service-dropdown-mb-sm-md  ${
                  isAppointmentsDropdownOpen ? "show" : ""
                }`}
                onMouseEnter={handleAppointmentsHover}
                onMouseLeave={handleAppointmentsLeave}
                style={{ position: "relative" }}
              >
                <a
                  className="mb-nav-link nav-link dropdown-toggle"
                  href="#!"
                  style={{ color: newNavIcon }}
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={isAppointmentsDropdownOpen}
                >
                  Appointments
                </a>
                <div
                  className={`dropdown-menu dropdown-menu-transition mb-nav-link ${
                    isAppointmentsDropdownOpen ? "show" : ""
                  }`}
                  aria-labelledby="navbarDropdown"
                  style={{
                    position: "absolute",
                    left: "0px", // Align the dropdown to the right
                    animation: `${
                      isAppointmentsDropdownOpen ? "slideIn" : "slideOut"
                    } 0.5s ease-in-out`, // Apply the animation
                  }}
                >
                  <a className=" mb-nav-link-inner-b dropdown-item" href="/Fee">
                    Fees
                  </a>
                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/Referrals"
                  >
                    Referrals
                  </a>
                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/Prescription"
                  >
                    Prescription
                  </a>
                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/Consultations"
                  >
                    Consultations
                  </a>
                  {/* <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/Paediatric"
                  >
                    Paediatric Dermatology Clinics
                  </a> */}
                </div>
              </li>

              <li
                className={`   nav-item px-1 service-dropdown-mb ${
                  isMedicalDropdownOpen ? "show" : ""
                }`}
                onMouseEnter={handleMedicalHover}
                onMouseLeave={handleMedicalLeave}
              >
                <a
                  className="mb-nav-link nav-link dropdown-toggle"
                  href="#!"
                  style={{ color: newNavIcon }}
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={isMedicalDropdownOpen}
                >
                  Medical Information
                </a>
                <div
                  className={`dropdown-menu mb-nav-link ${
                    isMedicalDropdownOpen ? "show" : ""
                  }`}
                  aria-labelledby="navbarDropdown"
                >
                  <a
                    className="  mb-nav-link-inner-b dropdown-item"
                    href="/TestProcedures"
                  >
                    Tests & Procedures
                  </a>
                  <a
                    className="  mb-nav-link-inner-b dropdown-item"
                    href="/SkinCancerAwareness"
                  >
                    Skin Cancer Awareness
                  </a>
                  <a
                    className="  mb-nav-link-inner-b dropdown-item"
                    href="/CommonSkinDiseases"
                  >
                    Common Skin Diseases
                  </a>
                  {/* <a
                    className="  mb-nav-link-inner-b dropdown-item"
                    href="/SkinConditionTreated"
                  >
                    Skin Conditions Treated
                  </a> */}
                  <a
                    className="  mb-nav-link-inner-b dropdown-item"
                    href="/GeneralSkinHealthAdvice"
                  >
                    General skin health advice
                  </a>
                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/TopicalTreatments"
                  >
                    How to apply topical treatments
                  </a>
                </div>
              </li>

              <li
                className={`nav-item px-1 service-dropdown-mb-sm-md ${
                  isMedicalDropdownOpen ? "show" : ""
                }`}
                onMouseEnter={handleMedicalHover}
                onMouseLeave={handleMedicalLeave}
                style={{ position: "relative" }}
              >
                <a
                  className="mb-nav-link nav-link dropdown-toggle"
                  href="#!"
                  style={{ color: newNavIcon }}
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={isMedicalDropdownOpen}
                >
                  Medical Information
                </a>
                <div
                  className={`dropdown-menu dropdown-menu-transition mb-nav-link ${
                    isMedicalDropdownOpen ? "show" : ""
                  }`}
                  aria-labelledby="navbarDropdown"
                  style={{
                    position: "absolute",
                    left: "0px", // Align the dropdown to the right
                    animation: `${
                      isMedicalDropdownOpen ? "slideIn" : "slideOut"
                    } 0.5s ease-in-out`, // Apply the animation
                  }}
                >
                  <a
                    className="  mb-nav-link-inner-b dropdown-item"
                    href="/TestProcedures"
                  >
                    Tests & Procedures
                  </a>
                  <a
                    className="  mb-nav-link-inner-b dropdown-item"
                    href="/SkinCancerAwareness"
                  >
                    Skin Cancer Awareness
                  </a>
                  <a
                    className="  mb-nav-link-inner-b dropdown-item"
                    href="/CommonSkinDiseases"
                  >
                    Common Skin Diseases
                  </a>
                  {/* <a
                    className="  mb-nav-link-inner-b dropdown-item"
                    href="/SkinConditionTreated"
                  >
                    Skin Conditions Treated
                  </a> */}
                  <a
                    className="  mb-nav-link-inner-b dropdown-item"
                    href="/GeneralSkinHealthAdvice"
                  >
                    General skin health advice
                  </a>
                  <a
                    className=" mb-nav-link-inner-b dropdown-item"
                    href="/TopicalTreatments"
                  >
                    How to apply topical treatments
                  </a>
                </div>
              </li>

              <li className=" nav-item px-1">
                <a
                  style={{ color: newNavIcon }}
                  className="mb-nav-link nav-link"
                  href="/MediaPublications"
                >
                  Media & Publications
                </a>
              </li>

              <li className=" nav-item px-1">
                <a
                  style={{ color: newNavIcon }}
                  className="mb-nav-link nav-link"
                  href="/Locations"
                >
                  Locations
                </a>
              </li>

              <li
                className={` nav-item px-1 service-dropdown-mb  ${
                  isBookDropdownOpen ? "show" : ""
                }`}
                onMouseEnter={handleBookHover}
                onMouseLeave={handleBookLeave}
              >
                <a
                  className="mb-nav-link nav-link dropdown-toggle"
                  href="#!"
                  style={{ color: newNavIcon }}
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={isBookDropdownOpen}
                >
                  Book an appointment
                </a>
                <div
                  className={`dropdown-menu mb-nav-link ${
                    isBookDropdownOpen ? "show" : ""
                  }`}
                  aria-labelledby="navbarDropdown"
                >
                  <a
                    className=" mb-nav-link-inner-b dropdown-item "
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.circlehealthgroup.co.uk/consultants/imtiaz-ahmed"
                  >
                    BMI Meriden Coventry
                  </a>
                  <a
                    className=" mb-nav-link-inner-b  dropdown-item"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.spirehealthcare.com/consultant-profiles/dr-imtiaz-ahmed-c4165334/"
                  >
                    Spire Leicester Hospital
                  </a>
                  <a
                    className=" mb-nav-link-inner-b  dropdown-item"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.nuffieldhealth.com/consultants/dr-imtiaz-ahmed-warwickshire"
                  >
                    Nuffield Health Warwickshire
                  </a>
                </div>
              </li>

              <li
                className={`nav-item px-1 service-dropdown-mb-sm-md ${
                  isBookDropdownOpen ? "show" : ""
                }`}
                onMouseEnter={handleBookHover}
                onMouseLeave={handleBookLeave}
                style={{ position: "relative" }}
              >
                <a
                  className="mb-nav-link nav-link dropdown-toggle"
                  href="#!"
                  style={{ color: newNavIcon }}
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={isBookDropdownOpen}
                >
                  Book an appointment
                </a>
                <div
                  className={`dropdown-menu dropdown-menu-transition mb-nav-link ${
                    isBookDropdownOpen ? "show" : ""
                  }`}
                  aria-labelledby="navbarDropdown"
                  style={{
                    position: "absolute",
                    left: "0px", // Align the dropdown to the right
                    animation: `${
                      isBookDropdownOpen ? "slideIn" : "slideOut"
                    } 0.5s ease-in-out`, // Apply the animation
                  }}
                >
                  <a
                    className=" mb-nav-link-inner-b dropdown-item "
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.circlehealthgroup.co.uk/consultants/imtiaz-ahmed"
                  >
                    BMI Meriden Coventry
                  </a>
                  <a
                    className=" mb-nav-link-inner-b  dropdown-item"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.spirehealthcare.com/consultant-profiles/dr-imtiaz-ahmed-c4165334/"
                  >
                    Spire Leicester Hospital
                  </a>
                  <a
                    className=" mb-nav-link-inner-b  dropdown-item"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.nuffieldhealth.com/consultants/dr-imtiaz-ahmed-warwickshire"
                  >
                    Nuffield Health Warwickshire
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;

// <a
//   className="btn-mbl btn btn-sm btn-outline-primary rounded-pill order-1 order-lg-0 ms-lg-4"
//   href="#!"
// >
//   Sign In
// </a>;
